export { DefaultGlobalStateProvider } from "@bitwarden/state";
